import { IReceipt, NgReason } from '@/types/receipt'
import { ISpecialOfferReceipt } from '@/types/special-offer'

export const hasNg = (
  receipt: IReceipt | ISpecialOfferReceipt | null,
): boolean => {
  if (receipt === null) {
    return false
  }
  return receipt.ngReason !== null || receipt.otherNgReason.length > 0
}

export const hasNonShopPhoneDateTimeNg = (
  receipt: IReceipt | null,
): boolean => {
  if (receipt === null) {
    return false
  }
  return (
    ![
      null,
      NgReason.NO_PHONE,
      NgReason.NO_SHOP,
      NgReason.NO_DATE_TIME,
    ].includes(receipt.ngReason) || receipt.otherNgReason.length > 0
  )
}

export const validatePhoneInfo = (receipt: IReceipt | null): boolean => {
  if (receipt === null) {
    return false
  }
  return receipt.phone !== null && receipt.phone.length > 0
}

export const validateShopInfo = (receipt: IReceipt | null): boolean => {
  if (receipt === null) {
    return false
  }
  if (receipt.phone === null) {
    return false
  }
  if (receipt.shop === null || receipt.shop.tel === null) {
    return false
  }
  if (receipt.shop.tel.replace(/-/g, '') !== receipt.phone.replace(/-/g, '')) {
    return false
  }
  return (
    receipt.shopId !== null &&
    receipt.shopId > 0 &&
    receipt.chainStoreId !== null &&
    receipt.chainStoreId > 0 &&
    receipt.channelId !== null &&
    receipt.channelId > 0
  )
}

export const validateRegisterShopInfo = (receipt: IReceipt | null): boolean => {
  if (receipt === null) {
    return false
  }
  return (
    receipt.shop !== null &&
    receipt.shop.name.length > 0 &&
    receipt.chainStoreId !== null &&
    receipt.chainStoreId > 0 &&
    receipt.channelId !== null &&
    receipt.channelId > 0
  )
}

export const validateDateTimeInfo = (receipt: IReceipt | null): boolean => {
  if (receipt === null) {
    return false
  }
  return receipt.dateTime !== null
}

export const validateProductInfo = (receipt: IReceipt | null): boolean => {
  if (receipt === null) {
    return false
  }
  return receipt.items.every(item => {
    return (
      item.name !== undefined && // can be undefined
      item.name !== null &&
      item.name.length > 0 &&
      item.matchedCode !== null &&
      item.matchedCode.length > 0 &&
      item.matchedName !== null &&
      item.matchedName.length > 0 &&
      item.price !== null &&
      item.quantity !== null
    )
  })
}

export const validatePaymentInfo = (receipt: IReceipt | null): boolean => {
  if (receipt === null) {
    return false
  }
  return receipt.payment !== null && receipt.payment.length > 0
}

export const validatePointInfo = (receipt: IReceipt | null): boolean => {
  if (receipt === null) {
    return false
  }
  return receipt.point !== null && receipt.point.length > 0
}
